import styled, { css } from 'styled-components';
import Spinner, { SpinnerSVG, SpinnerText } from '../../../components/spinner';
import Typography from '../../../components/typography';
import { stylePropertiesToCss } from '../../../design-tokens/style-mixins';
import { pxToRem } from '../../../design-tokens/style-utilities';
import { ANWBDefault } from '../../../design-tokens/theme';
const SPINNER_SIZE = 30;
/**
 * Input Wrapper
 * @deprecated
 */
export const inputWrapperStyles = () => css `
	position: relative;
	width: 100%;
`;
/**
 * @deprecated
 */
export const InputWrapper = styled.div `
	${inputWrapperStyles}
`;
/**
 * @deprecated
 */
export const inputContainerStyles = ({ theme, $invalid, $loading, }) => css `
	&& {
		/* @NOTE: Make selector more specific due to CORE-UI clashes */
		appearance: none;
		width: 100%;
		padding: ${pxToRem(theme.spacing['200'])};
		border-radius: ${pxToRem(theme.borderRadius.m)};
		border: ${pxToRem(theme.borderWidth['2'])} solid ${theme.colors.medium.borderFormField};
		color: ${theme.colors.base.textFormFieldInput};
		background-color: ${theme.colors.blanc.bgFormField};
		height: ${pxToRem(Number(theme.spacing['200']) * 2 +
    Number(theme.typography.formFields['100FieldHintText'].lineHeight))};

		&[type='text'],
		&[type='search'],
		&[type='tel'],
		&[type='email'] {
			text-overflow: ellipsis;
		}

		&[type='number'] {
			&::-webkit-inner-spin-button {
				height: auto;
			}

			&::-webkit-outer-spin-button {
				height: auto;
			}
		}

		&[type='search'] {
			box-sizing: inherit;

			&::-webkit-search-cancel-button {
				appearance: none;
			}

			&::-webkit-search-decoration {
				appearance: none;
			}
		}

		&[type='file'] {
			padding: ${pxToRem(Number(theme.spacing['200']) - 1)} ${pxToRem(theme.spacing['200'])};
			cursor: pointer;
		}

		&:focus {
			border-color: ${theme.colors.highlight.borderHover};
			outline: 0;
		}

		&:disabled {
			color: ${theme.colors.medium.textInactive};
			border-color: ${theme.colors.light.borderFormFieldDisabled};
			background-color: ${theme.colors.extralight.bgFormFieldDisabled};

			&::placeholder {
				color: ${theme.colors.medium.textInactive};
			}
		}

		&::placeholder {
			color: ${theme.colors.informative.textFormField};

			${stylePropertiesToCss(Object.assign(Object.assign({}, theme.typography.formFields['100FieldHintText']), { fontStyle: theme.name === ANWBDefault.name ? 'Italic' : 'Normal' }))}
		}

		&:valid,
		&:invalid {
			box-shadow: none;
		}

		${$invalid &&
    css `
			:not(:disabled) {
				border: ${pxToRem(theme.borderWidth['2'])} solid ${theme.colors.error.borderFormField};

				&:focus {
					border-color: ${theme.colors.highlight.borderHover};
					outline: 0;
				}
			}
		`}

		${$loading &&
    css `
			&& {
				padding-right: calc(
					${pxToRem(SPINNER_SIZE)} +
						(2 * ${pxToRem(Number(theme.spacing['200']) - Number(theme.borderWidth['2']) * 2)})
				);
			}
		`}
	}
`;
/**
 * @deprecated
 */
export const InputContainer = styled(Typography).attrs(() => ({
    tagName: 'input',
})) `
	${inputContainerStyles}
`;
/**
 * Input Spinner
 * @deprecated
 */
export const inputSpinnerStyles = ({ theme }) => css `
	opacity: 1;
	position: absolute;
	top: ${pxToRem(theme.typography.formFields['100FieldHintText'].lineHeight)};
	right: 0;
	transform: translate(-${pxToRem(theme.spacing[200])}, -50%);

	${SpinnerSVG} {
		width: ${pxToRem(SPINNER_SIZE)};
		height: ${pxToRem(SPINNER_SIZE)};
	}

	${SpinnerText} {
		white-space: nowrap;
	}
`;
export const InputSpinner = styled(Spinner) `
	${inputSpinnerStyles}
`;
